// Notification queries. Consumed by both the components in this
// package (NotificationBell + NotificationPanel) and by any app that
// wants to prime `root.notifications` on login or refresh it
// imperatively.

import { getClient, PROJECT_GOVERNANCE } from '../../../governanceBridge.js'

const _sb = () => getClient(PROJECT_GOVERNANCE)

export const listNotifications = async ({ recipientEmail, limit = 50 } = {}) => {
  const sb = _sb()
  if (!sb) return { data: [], error: null }
  let q = sb
    .from('notifications')
    .select('*')
    .order('created_at', { ascending: false })
    .limit(limit)
  if (recipientEmail) q = q.eq('user_email', recipientEmail)
  return q
}

// Mark one notification as read. Optimistic: caller updates root
// state immediately; this fires the server write in the background.
export const markRead = async (notifId) => {
  const sb = _sb()
  if (!sb) return { error: new Error('governance unavailable') }
  return sb.from('notifications').update({ read: true }).eq('id', notifId)
}

export const markAllRead = async (recipientEmail) => {
  const sb = _sb()
  if (!sb) return { error: new Error('governance unavailable') }
  return sb
    .from('notifications')
    .update({ read: true })
    .eq('user_email', recipientEmail)
    .eq('read', false)
}
